import { Logger, LOG_DEBUG } from './logging';

// Get environment from URL in address bar.
function getEnvironment() {
    if ( /localhost/.test( window.location.hostname ) ) {
        return 'qa';
    }
    
    return window.location.hostname.toLowerCase().split( '.' ).find( ( chunk ) => {
        return [ 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
}

const env = getEnvironment();

function getURL( url ) {
    const env = getEnvironment();
    return url.replace( '(env.)', env ? env + '.' : '' );
}

/**
 * getGantryUrl will fetch appropriate URL for the environment to connect to gantry data catalog
 *
 * @returns { string }
 */
const getGantryUrl = () => {

	if ( env === 'qa' || env === 'pprd' ) {
		Logger( LOG_DEBUG, 'getGantryUrl fetching non-prod endpoint' );
		return `https://${ env ? env + '.' : '' }superior-eu${ env ? '-np' : '' }.dlake${ env ? '-np' : '' }.api.biw.cloud/v1/gantry-curator`;
	}
    
	return 'https://prod.superior-eu-prod.data-lake.api.biw.cloud/v1/gantry-curator';
};



export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const digsURL = getURL( 'https://(env.)api.biw.cloud/v1/digs' ); 
export const liftBridgeURL = getURL( 'https://(env.)api.biw.cloud/liftbridge/v1' );
export const gantryCuratorUrl = getGantryUrl();
